// extracted by mini-css-extract-plugin
export default {"facebookLogin":"FacebookButton_facebookLogin__ItqEG"};